

//  getting api from env variables 


export const API = process.env.REACT_APP_API_URL;
// console.log("API URL:", API);